/**
 * Constants for the attach-source flow.
 *
 * Lives in its own module so the modal component file (`AttachKnowledgeSourceModal.tsx`)
 * exports only React components. Vite's Fast Refresh requires component
 * files to export only components — mixing in a non-component export
 * forces a full module reload on every edit.
 */

export const ATTACHABLE_CATEGORIES = [
  'missing_knowledge',
  'segment_mismatch',
] as const;

export type AttachableCategory = (typeof ATTACHABLE_CATEGORIES)[number];
